import { Button, createTheme, ThemeProvider } from '@mui/material';

interface Props {
  color: string;
  className?: string;
  contrastText?: string;
  children: JSX.Element | string;
  onClick: () => void;
}

const CustomButton = ({ color, contrastText, children, onClick }: Props) => {
  const theme = createTheme({
    palette: {
      primary: {
        main: color,
        contrastText: contrastText ?? '#FFFFFF'
      }
    }
  });

  return (
    <ThemeProvider theme={theme}>
      <Button variant='contained' onClick={onClick}>
        {children}
      </Button>
    </ThemeProvider>
  );
};

export default CustomButton;
